import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const PadaidLogo = ({ size = 'md', showText = true, interactive = true }) => {
  const [clicked, setClicked] = useState(false);

  // Tailles agrandies par rapport à la version précédente
  const sizes = {
    sm: { container: 'w-10 h-10', text: 'text-lg' },
    md: { container: 'w-16 h-16', text: 'text-2xl' },
    lg: { container: 'w-20 h-20', text: 'text-3xl' },
    xl: { container: 'w-28 h-28', text: 'text-4xl' },
    xxl: { container: 'w-48 h-48', text: 'text-5xl' },
  };

  const handleClick = () => {
    if (!interactive) return;
    setClicked(true);
    window.setTimeout(() => setClicked(false), 500);
  };

  return (
    <Link
      to="/home"
      className="flex items-center space-x-3 group"
      aria-label="Aller à l'accueil"
      onClick={handleClick}
    >
      {/* Logo PADAID Animé - Vidéo, interactif au survol/clic */}
      <div className="relative">
        {interactive && (
          <span
            className={`absolute inset-0 rounded-full transition-all duration-300 pointer-events-none
              ${clicked ? 'ring-4 ring-primary/70 scale-125 opacity-0' : 'ring-0 scale-100 opacity-0 group-hover:opacity-100 group-hover:ring-4 group-hover:ring-primary/40 group-hover:scale-110'}`}
            style={{ transitionProperty: 'transform, opacity, box-shadow' }}
          />
        )}
        <div
          className={`${sizes[size].container} relative flex items-center justify-center overflow-hidden rounded-full transition-transform duration-300 ease-out
            ${interactive ? 'group-hover:scale-110 group-hover:shadow-[0_0_25px_hsl(var(--primary)/0.5)]' : ''}
            ${clicked ? 'scale-95' : ''}`}
        >
          <video
            autoPlay
            loop
            muted
            playsInline
            poster="/assets/padaid-logo.png"
            className="w-full h-full object-cover"
            style={{ objectFit: 'cover' }}
          >
            <source
              src="https://customer-assets.emergentagent.com/job_mvp-creator-1/artifacts/kdze16th_Design%20sans%20titre.mp4"
              type="video/mp4"
            />
            {/* Fallback pour navigateurs sans support vidéo */}
            <img
              src="/assets/padaid-logo.png"
              alt="Logo PADAID - Mains protégeant le globe"
              className="w-full h-full object-contain"
            />
          </video>
        </div>
      </div>

      {/* Texte PADAID */}
      {showText && (
        <div className={`padaid-logo ${sizes[size].text} transition-transform duration-300 ${interactive ? 'group-hover:scale-105' : ''}`}>
          <span className="pa-red">PA</span>
          <span className="daid-green">DAID</span>
        </div>
      )}
    </Link>
  );
};

export default PadaidLogo;
